import { NgModule } from '@angular/core';
import { ServiceLanguageNamePipe } from 'app/pipes/service-language-name-pipe/service-language-name.pipe';

@NgModule({
    declarations: [ServiceLanguageNamePipe],
    providers: [ServiceLanguageNamePipe],
    exports: [ServiceLanguageNamePipe],
})
export class ServiceLanguageNamePipeModule { }